var _title, _desc, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgBook = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "31px",
    height: "38px",
    viewBox: "0 0 31 38",
    ref: svgRef
  }, props), title === undefined ? _title || (_title = /*#__PURE__*/React.createElement("title", null, "B234657C-EAA9-457C-84E8-1C8C7AA40680")) : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with sketchtool.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "BITACore-New-Workflow",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Universe-Builder---New-Workflow---08",
    transform: "translate(-1074.000000, -715.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-43",
    transform: "translate(297.000000, 264.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-40",
    transform: "translate(0.000000, 49.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-38-Copy-2",
    transform: "translate(598.000000, 332.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-32-Copy-6"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-31"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-30",
    transform: "translate(172.100000, 66.250000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-12"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-19"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Geography"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-8"
  }, /*#__PURE__*/React.createElement("g", {
    id: "User---Index---Icon"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-7"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Available-Filters---01-Outlined-/-Action-/-book"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Outlined-/-Action-/-book"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    points: "0 0 45 0 45 45 0 45"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.75,3.75 L11.25,3.75 C9.1875,3.75 7.5,5.4375 7.5,7.5 L7.5,37.5 C7.5,39.5625 9.1875,41.25 11.25,41.25 L33.75,41.25 C35.8125,41.25 37.5,39.5625 37.5,37.5 L37.5,7.5 C37.5,5.4375 35.8125,3.75 33.75,3.75 Z M16.875,7.5 L20.625,7.5 L20.625,16.875 L18.75,15.46875 L16.875,16.875 L16.875,7.5 Z M33.75,37.5 L11.25,37.5 L11.25,7.5 L13.125,7.5 L13.125,24.375 L18.75,20.15625 L24.375,24.375 L24.375,7.5 L33.75,7.5 L33.75,37.5 Z",
    id: "\\uD83D\\uDD39-Icon-Color",
    fill: "#FFFFFF"
  })))))))))))))))))))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgBook, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/book.d91830b5.svg";
export { ForwardRef as ReactComponent };